import _ from 'lodash'
import * as CarePlanActions from '../actions/CarePlans'
import * as FormActions from '../actions/Forms'
import { getJSON } from '../common/services/api'

export function fetchResidentAdls(id) {
  return (dispatch) => {
    dispatch(CarePlanActions.setResidentAdls(null, id))
    const url = `/api/list/residents/${id}/adls`
    return getJSON({ url })
      .then((res) => {
        dispatch(CarePlanActions.setResidentAdls(res.result, id))
      })
      .catch((e) => {
        console.log(e)
      })
  }
}

export function fetchCarePlanHistory(resident, carePlanId) {
  return (dispatch, getState) => {
    const { startDate, endDate } = getState().carePlans.historyDateRange
    dispatch(CarePlanActions.setCarePlanHistory(null)) // show loading in history screen

    let url = `/api/list/care-plans?resident=${resident}`
    if (carePlanId) {
      url += `&carePlanId=${carePlanId}`
    }
    if (startDate) {
      url += `&from=${startDate.toISOString()}`
    }
    if (endDate) {
      url += `&to=${endDate.toISOString()}`
    }

    return getJSON({ url })
      .then((res) => {
        dispatch(CarePlanActions.setCarePlanHistory(res.result))
      })
      .catch((e) => {
        console.log(e)
      })
  }
}

export function addCarePlanRiskAssessment(riskAssessmentId, formId) {
  return (dispatch, getState) => {
    const { forms, data } = getState()

    const riskAssessments = getValidItems(
      riskAssessmentId,
      forms[formId].fields.riskAssessments,
      data['risk-assessments']
    )
    const reviewedAssessments = getValidItems(
      riskAssessmentId,
      forms[formId].fields.reviewedAssessments,
      data['risk-assessments']
    )

    dispatch(
      FormActions.setFormField({
        key: 'riskAssessments',
        value: sortUniqueItems(riskAssessments, 'form.formId'),
        formId
      })
    )

    dispatch(
      FormActions.setFormField({
        key: 'reviewedAssessments',
        value: sortUniqueItems(reviewedAssessments, 'form.formId'),
        formId
      })
    )
  }
}

export function addCarePlanDocument(document, formId) {
  return (dispatch, getState) => {
    const { forms } = getState()
    if (!document || !document.id || !forms[formId]) return null

    const currentIds = forms[formId].fields.documents || []
    const mergedIds = _.uniq([...currentIds, document.id]).sort()

    dispatch(
      FormActions.setFormField({
        key: 'documents',
        value: mergedIds,
        formId
      })
    )
  }
}

const getValidItems = (itemId, currentItems = [], list) => {
  const newItems = [itemId, ...currentItems]
  return newItems.map((id) => _.find(list, { id }))
}

const sortUniqueItems = (items, property) => {
  return _.uniqBy(items, property)
    .filter((item) => item)
    .map((item) => item.id)
    .sort()
}
